export default __webpack_public_path__ + "47d36f864f317029d54eb94c37531656.png";